import { all, call, put, takeLatest } from 'redux-saga/effects'
import { REQUEST_BIND_LIST, RECEIVE_BIND_LIST } from '../constants'
import { fetchBindList } from '../services'

function* yieldBindList(action: any) {
  try {
    const response = yield call(fetchBindList, action.payload)
    yield put({ type: RECEIVE_BIND_LIST, ...response })
    // TODO:更好的回调方式，promise?
    if (action.callback) {
      action.callback(response)
    }
  } catch (err) {
    console.log(err)
  }
}

export function* watchYieldBind() {
  yield all([takeLatest(REQUEST_BIND_LIST, yieldBindList)])
}



// WEBPACK FOOTER //
// ./src/saga/bind.tsx